import Vue from 'vue'
import VueI18n from 'vue-i18n'
import VueRouter from 'vue-router'

import Search from './components/search.vue';

Vue.use(VueI18n)
Vue.use(VueRouter)

Vue.config.lang = 'no';
var locales = require('./translations/no')

const i18n = new VueI18n({
  locale: 'no',
  messages: locales
})
const router = new VueRouter()

new Vue({
	el: '#literaturesearch',
	//render: h => h(Search),
  components: { Search },
  i18n, router
});



// WEBPACK FOOTER //
// ./src/search.js